import { ReactElement, ReactNode } from 'react';
import { Text, GridItem } from '@chakra-ui/react';

import Heading from 'components/atoms/heading';

export interface RegistrationStepProps {
  step: string;
  title: string | ReactNode;
  subTitle: string | ReactNode;
  text: string | ReactNode;
}

const RegistrationStep = ({
  step,
  title,
  subTitle,
  text,
}: RegistrationStepProps): ReactElement => (
  <GridItem data-testid='registration-step'>
    <Text fontSize='20px' fontFamily='heading' color='primary.500' mb='4'>
      {step}
    </Text>

    <Heading format='h3' mb='4'>
      {title}
    </Heading>

    <Text fontSize='14px' color='primary.500' mb='4'>
      {subTitle}
    </Text>

    <Text fontSize='16px' color='text.200' w={['100%', '100%', '80%', '80%']}>
      {text}
    </Text>
  </GridItem>
);

export default RegistrationStep;
